import arc3DeviceImage from '@nexus/ari-lib/assets/images/devices/AR_DEVICES_UI_Arc_3.webp';
import navDeviceImage from '@nexus/ari-lib/assets/images/devices/AR_DEVICES_UI_Nav.webp';
import navZ1DeviceImage from '@nexus/ari-lib/assets/images/devices/AR_DEVICES_UI_NavZ1.webp';
import rockidDeviceImage from '@nexus/ari-lib/assets/images/devices/AR_DEVICES_UI_Rockid.webp';
import vuzixDeviceImage from '@nexus/ari-lib/assets/images/devices/AR_DEVICES_UI_Vuz.webp';
import { UiDeviceItem } from '../../hooks/use-devices';

export function getDeviceImage(device: UiDeviceItem) {
  if (device.model === 'ARC 3') {
    return arc3DeviceImage;
  }
  if (device.model === 'NAVIGATOR-Z1') {
    return navZ1DeviceImage;
  }
  if (device.model === 'ROKID GLASSES') {
    return rockidDeviceImage;
  }
  if (device.model === 'Vuzix M400') {
    return vuzixDeviceImage;
  }
  if (['Navigator 5XX', 'NAV500', 'NAV520'].includes(device.model)) {
    return navDeviceImage;
  }
  return null;
}
